import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-black text-brand-text font-sans selection:bg-brand-red selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ContactSection data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
    </div>;
}